import { createSlice } from '@reduxjs/toolkit'

type InitialState = {
  templateHistoryData: []
  templateHistorySummary: {}
  rowCount: number
}

const initialState: InitialState = {
  templateHistoryData: [],
  templateHistorySummary: {},
  rowCount: 0,
}

export const templateHistorySlice = createSlice({
  name: 'templateHistory',
  initialState,
  reducers: {
    getTemplateHistoryDetail: (state, action) => {
      const { templateHistoryData, rowCount } = action.payload
      state.templateHistoryData = templateHistoryData
      state.rowCount = rowCount
    },
    getSummary: (state, action) => {
      const { summary } = action.payload
      state.templateHistorySummary = summary
    },
  },
})

// Action creators are generated for each case reducer function
export const { getTemplateHistoryDetail, getSummary } =
  templateHistorySlice.actions

export default templateHistorySlice.reducer
